const errorMessages = {
  generic: 'Something went wrong. Please try again.',
  internetConnection: 'Please check your internet connection and try again later.',
  emptyField: 'Please fill in this field.',
  invalidEmail: 'Please enter a valid email address.',
  configurationExists: 'The configuration for this community already exists.'
}

export default errorMessages
